export const getArrayWithoutDuplicates = (arr) => [...new Set(arr)]
